import type { ButtonHTMLAttributes } from 'react';
import styles from './HelpButton.module.css';

interface Props extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  /** Accessible name, e.g. "Help: Payments". */
  label: string;
  /** Short visible word beside the icon; omitted = icon only (dialog headers). */
  text?: string;
}

/**
 * The "?" that opens help for what is on screen: a round outlined question mark (24-grid stroke SVG,
 * currentColor), optionally with a word. Used in the page header and in dialog headers.
 */
export function HelpButton({ label, text, className, type = 'button', ...rest }: Props) {
  return (
    <button
      {...rest}
      type={type}
      className={`${styles.help} ${text ? styles.withText : ''} ${className ?? ''}`}
      aria-label={label}
      title={label}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <circle cx="12" cy="12" r="9.5" />
        <path d="M9.3 9.2a2.8 2.8 0 0 1 5.4 1c0 1.9-2.7 2.4-2.7 4" />
        <path d="M12 17.6h.01" />
      </svg>
      {text && <span>{text}</span>}
    </button>
  );
}
